import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Grid,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import GlobalCard from "../../../../components/GlobalCardComponent";
import PrimarySmallBlueButton from "../../../../components/customButtons/PrimarySmallBlueButton";
import LaptopIcon from "@mui/icons-material/Laptop";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
import BookDemoForm from "../../../allClasses/BookDemoForm";
import CustomPopup from "../../../../components/customPopup/CustomPopup";
import GlobalMessageModal from "../../../../components/customPopup/GlobalMessageModal";
import ConfimationPopup from "../../../../components/customPopup/ConfimationPopup";
import ArticleIcon from "@mui/icons-material/Article";
import { getUpcommingDemos } from "../../Api/DashboardApi";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import ViewUpcommingDemoCard from "./ViewUpcommingDemoCard";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";

export default function NewBookDemoCard() {
  const userId = localStorage.getItem("userId");
  const [openBookDemo, setOpenBookDemo] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  const [demoData, setDemoData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Book Demo
  const handleOpenBookDemo = (data) => {
    setOpenBookDemo(true);
  };

  const handleCloseBookDemo = () => {
    setOpenBookDemo(false);
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await getUpcommingDemos(userId);
        setDemoData(data?.data);
      } catch (err) {
        console.error("Could not fetch user details");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  return (
    <>
      <CustomCardWithBorder height="100%" boxShadow={true}>
        <Grid container spacing={2} sx={{ minHeight: "100%" }}>
          {loading ? (
            <Grid item xs={12}>
              <Loader height="10vh" text="Loading Demos..." />{" "}
            </Grid>
          ) : !loading && demoData?.length === 0 ? (
            <>
              <Grid item>
                <Grid
                  container
                  position="relative"
                  spacing={1}
                  xs={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ minHeight: "100%" }}
                >
                  <Grid item xs={12}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      gap={1}
                    >
                      {/* <Box >
                          <img src="/newdashboard/Demo/Group 1171283537.png" />
                        </Box> */}
                      <Typography
                        fontSize="22px"
                        color="#161719"
                        sx={{ fontWeight: 600, fontFamily: "Inter" }}
                      >
                        Book Your Free Demo
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    mt={2}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Box width={76}>
                      <img src="/newdashboard/Demo/Group 35891.png" />
                    </Box>
                  </Grid>

                  <Grid item xs={12} textAlign="center"     mt={2}>
                    <Typography
                      fontSize="18px"
                      color="#313439"
                      sx={{ fontWeight: 600, fontFamily: "Inter" }}
                    >
                      Start Your Test Prep Right !
                    </Typography>
                  </Grid>

                  <Grid item xs={12} textAlign="center">
                    <Typography
                      fontSize="13px"
                      color="#313439"
                      px={2}
                      sx={{
                        fontWeight: 500,
                        fontFamily: "Inter",
                        lineHeight: "1.4",
                      }}
                    >
                      Book a free demo class and get guidance tailored to your
                      target exam.
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    mt={3}
                    textAlign="center"
                    container
                    sx={{
                      justifyContent: {
                        xs: "center", // On extra-small screens
                        sm: "center", // On small and up
                        xl: "center",
                        lg: "center",
                      },
                    }}
                  >
                    <BlueSmallButton
                      buttonTitle="Schedule Demo"
                      borderRadius="14px"
                      endIcon={<LaptopIcon />}
                      onClick={handleOpenBookDemo}
                    />
                  </Grid>

                  {/* <Box position="absolute" bottom={-12} left={5}>
                    <img src="/newdashboard/Demo/Group 1171281977.png" />
                  </Box>
                  <Box position="absolute" top={0} right={-10}>
                    <img src="/newdashboard/Demo/Group 1171281975.png" />
                  </Box> */}
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <ViewUpcommingDemoCard demoData={demoData} />
            </Grid>
          )}
        </Grid>{" "}
      </CustomCardWithBorder>

      <CustomPopup
        handleClose={handleCloseBookDemo}
        component={
          <BookDemoForm
            handleClose={handleCloseBookDemo}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={openBookDemo}
        title="Book a demo session"
        titleColor="#000000"
        maxWidth="md"
        titleAlign="center"
      />
      <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            const
            text="Demo Session Booked !."
            subText="Your demo session has been booked. We’ve reserved your slot and shared the details with you."
            buttonTitle="View Demo"
            startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
